// ViewModalFooter.jsx

import React from 'react';

// Components
import Button from 'components/button/Button';
import ModalButtons from 'components/modal/buttons/ModalButtons';

/**
 * ViewModalFooter
 *
 * Renders the action button row for ViewModal.
 *
 * @returns {ReactNode} The rendered component.
 */
const ViewModalFooter = ({ isEditMode, canDelete = true, onCancel, onSave, onDelete }) => {

  // ----- RENDER ----- //

  return (
    <ModalButtons
        style={{
            justifyContent: 'space-between',
        }}>

        {isEditMode && canDelete && (
            <Button
              iconKey="delete"
              label="Delete"
              onClick={onDelete}
            />
        )}

        <div style={{
            display: 'flex',
            gap: '8px',
        }}>
            <Button
              iconKey="close"
              label="Cancel"
              onClick={onCancel}
            />
            <Button
              iconKey="check"
              label="Save"
              onClick={onSave}
            />
        </div>

    </ModalButtons>
  );
};

// Dev Tools
ViewModalFooter.displayName = 'ViewModalFooter';

export default ViewModalFooter;
